import styled from 'styled-components';

export const SignInFormContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 380px;
	h2 {
		margin: 10px 0;
	}
`;
export const SignInButtons = styled.div`
	display: flex;
	justify-content: space-between;
`;
